import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { newStaff } from './newStaff';
import { staffUpdated } from './staffUpdated';

export const outputActions = [newStaff, staffUpdated];

export type OutputActions = ActionsOfCreators<typeof outputActions>;

export type Handler<T extends OutputActions> = FeatureHandler<T, OutputActions>;
